import { type TabListProps, TabList as ChakraTabList } from '@/ui';

export const TabList = (props: TabListProps) => {
  return <ChakraTabList {...props} borderBottom="none" />;
};
